
@if(isLoading || loadingOverride){
    <div class="position-absolute w-100 h-100 bg-dark opacity-50 loading-overlay-z">
        <div class="position-absolute top-50 start-50 translate-middle mb-10">
            <h1 class="text-white-50">Trifecta Portal</h1>
            <h3 class="text-white-50">Loading...</h3>
        </div>

    </div>
}
